export default "__VITE_ASSET__D$Q0$ezR__"